module.exports = __webpack_public_path__ + "h5/img/apply.ea364f3e.png";